/** YYYY-MM-DD HH:mm:ss (24h) for Progress / Live build panel log lines */
export function formatBuildPanelTimestamp(date: Date): string {
    const datePart = date.toLocaleDateString('en-CA', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    });
    const timePart = date.toLocaleTimeString('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
    });
    return `${datePart} ${timePart}`;
}
